import CodeSnippetBlock from "ds/components/CodeSnippetBlock";
import FormField, { FormFieldProps } from "ds/components/Form/Field";

type FormFieldViewCodeProps = {
  code: string;
  maxHeight?: string;
  language?: string;
} & Pick<
  FormFieldProps,
  "label" | "tooltipInfo" | "tooltipInfoVariant" | "noMargin" | "onCopyCallback"
>;

const FormFieldViewCode = ({
  code,
  label,
  tooltipInfo,
  tooltipInfoVariant,
  noMargin,
  maxHeight,
  language,
  onCopyCallback,
}: FormFieldViewCodeProps) => {
  return (
    <FormField
      label={label}
      tooltipInfo={tooltipInfo}
      tooltipInfoVariant={tooltipInfoVariant}
      noMargin={noMargin}
    >
      <CodeSnippetBlock allowCopy language={language} maxHeight={maxHeight} onCopy={onCopyCallback}>
        {code}
      </CodeSnippetBlock>
    </FormField>
  );
};

export default FormFieldViewCode;
